import { createElementFromHTML, insertAfter, showElement } from "./utils.mjs";

let confirmationContainer = document.querySelector(
  ".booking-engine-confirmation"
);

// Value should be an integer number of cents to avoid floating point issues
// E.g. $145.31 should be passed in as 14531
function formatCurrency(value) {
  let dollars = value / 100;
  return dollars.toLocaleString("en-Us", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

if (confirmationContainer) {
  let bookingData = location.search.match(/data=(.*)/);
  if (bookingData?.length === 2) {
    try {
      // Decode the base64 encoded "data" parameter, then parse the JSON to get an object
      bookingData = atob(bookingData[1]);
      bookingData = JSON.parse(bookingData);
    } catch (exception) {
      // If there was a problem decoding the data parameter, redirect back to this location's booking page
      let propertyName = WindCreekData.propertyName.toLowerCase().replace(/\s/g, '');
      window.location.replace("/" + propertyName + "/book-now");
    }

    document.querySelector("[data-confirmation-number]").textContent =
      bookingData.confirmationNumber;
    document.querySelector("[data-name]").textContent = bookingData.guestName;
    document.querySelector("[data-email]").textContent = bookingData.email;
    document.querySelector("[data-phone]").textContent = bookingData.phone;
    document.querySelector("[data-checkin-date]").textContent =
      bookingData.checkIn;
    document.querySelector("[data-checkout-date]").textContent =
      bookingData.checkOut;
    document.querySelector("[data-stay-details]").textContent =
      bookingData.stayDetails;

    /*
		Find specific named elements (e.g. subtotal) in the lineItems array and assign them to variables so we can
		put them in the correct place in the DOM. All remaining elements will be considered line items that belong under
		the room information.
		*/
    let discount;
    let subtotal;
    let tax;
    let total;
    let smoking;
    let accessible;
    let rooms = [];
    bookingData.lineItems.forEach((item) => {
      switch (item.name.toLowerCase()) {
        case "discount":
          discount = item.price;
          break;
        case "subtotal":
          subtotal = item.price;
          break;
        case "tax":
          tax = item.price;
          break;
        case "total":
          total = item.price;
          break;
        default:
          rooms.push(item);
          break;
      }
    });

    // console.log(rooms);

    // Add the rows under the room information heading
    let roomInformationElement = document.querySelector(
      "[data-room-information]"
    );
    rooms.forEach((room) => {
      let rowHTML = `
        <div class="d-flex justify-content-between">
					<span>${room.quantity} ${room.name}</span>
					<span class="fw-medium text-dark-subtle">${formatCurrency(room.price)}</span>
				</div>
			`;

      let row = createElementFromHTML(rowHTML, "div", true);

      if (room.details) {
        let roomDetailsElement = document.querySelector("[data-room-information]");
        let smoking = '';
        let accessible = '';
        for (let detail of room.details) {
          switch (detail) {
            case "Non-Smoking":
              smoking = `<span class="material-icons text-primary" data-smoke-free>smoke_free</span>`;
              break;
            case "Smoking":
              smoking = `<span class="material-icons text-primary" data-smoke-free>smoking_rooms</span>`;
              break;
            case "Accessible":
              accessible =
                '<span class="material-icons text-primary" data-accessible>accessibility_new</span>';
              break;
          }
        }
        const detailHtml = `<div class="d-flex gap-3">
          ${smoking}
          ${accessible}
        </div>`;
        let detailRow = createElementFromHTML(detailHtml, "div", true);
        insertAfter(detailRow, roomDetailsElement);
      }
      insertAfter(row, roomInformationElement);
    });

    if (bookingData.hotelStayPreferences && bookingData.hotelStayPreferences.length > 0) {
      let preferencesHtml = '';
      bookingData.hotelStayPreferences.forEach((preference) => {
        let preferenceLabel = '';
        if (preference.optionCode === 'ENABLED') {
          preferenceLabel += `${preference.categoryName}`;
        } else {
          preferenceLabel += `${preference.optionName}`;
        }
        preferencesHtml += `
          <div class="g-col-6">
            <div class="d-flex">
              <span class="material-icons text-primary pe-1">check</span>
              <span>${preferenceLabel}</span>
            </div>
          </div>
        `;
      });
      let preferencesContainer = document.querySelector("[data-room-preferences-list]");
      let preferencesElements = createElementFromHTML(preferencesHtml);
      preferencesElements.forEach((preferenceElement) => {
        preferencesContainer.append(preferenceElement);
      });
      showElement("[data-room-preferences]");
    }

    if (discount > 0) {
      document.querySelector("[data-discount]").textContent =
        formatCurrency(discount);
      showElement("[data-discount-row]");
    }

    document.querySelector("[data-subtotal]").textContent =
      formatCurrency(subtotal);
    document.querySelector("[data-tax]").textContent = formatCurrency(tax);
    document.querySelector("[data-total]").textContent = formatCurrency(total);

    if (bookingData.chargesSummary.discount > 0) {
      document.querySelector("[data-details-discount]").textContent =
        formatCurrency(bookingData.chargesSummary.discount);
      showElement("[data-details-discount-row]");
    }

    // Add the list of nightly charges under the discount row
    let detailsDiscountRow = document.querySelector(
      "[data-details-discount-row]"
    );
    bookingData.chargesSummary.nightlyCharges.forEach((nightlyCharge) => {
      let rowHTML = `
        <div class="d-flex justify-content-between">
					<span>${nightlyCharge.postingDate}</span>
					<span class="fw-medium text-dark-subtle">${formatCurrency(
            nightlyCharge.totalCharges
          )}</span>
				</div>
        <hr class="m-0">
			`;
      let row = createElementFromHTML(rowHTML, "div", true);

      // Remove the <tbody> that the browser automatically adds in the previous function call
      row = row.firstElementChild;

      insertAfter(row, detailsDiscountRow);
    });

    document.querySelector("[data-details-nightly-average]").textContent =
      formatCurrency(bookingData.chargesSummary.nightlyAverage);
    document.querySelector("[data-details-subtotal]").textContent =
      formatCurrency(bookingData.chargesSummary.subTotal);
    document.querySelector("[data-details-tax]").textContent = formatCurrency(
      bookingData.chargesSummary.taxesAndFees
    );
    document.querySelector("[data-details-total]").textContent = formatCurrency(
      bookingData.chargesSummary.total
    );

    document.querySelector("[data-email-confirmation]").textContent =
      bookingData.email;
  } else {
    // If the data parameter is missing, redirect back to this location's booking page
    let propertyName = WindCreekData.propertyName.toLowerCase().replace(/\s/g, '');
    window.location.replace("/" + propertyName + "/book-now");
  }

  document
    .querySelector("[data-print-button]")
    .addEventListener("click", (event) => {
      // openAllDialogs()
      window.print();
    });

  function openAllDialogs() {
    confirmationContainer.querySelector(".accordion").forEach((details) => {
      details.show();
    });
  }

  window.onbeforeprint = (event) => {
    openAllDialogs();
  };
}

/*
Example JSON structure that gets passed into the "data" URL parameter on page load:
{
	"confirmationNumber": "42485781",
	"guestName": "Chris Bryant",
	"email": "cbryant@caxy.com",
	"phone": "4234234234",
	"checkIn": "11/27/2023",
	"checkOut": "11/28/2023",
	"stayDetails": "1 Night, 1 Guest",
	"lineItems": [
		{
			"quantity": 1,
			"name": "Accessible King Non-Smoking",
			"price": 14900,
			"originalPrice": null,
			"details": [
				"Non-Smoking",
				"Accessible"
			]
		},
		{
			"name": "Discount",
			"price": 0
		},
		{
			"name": "Subtotal",
			"price": 14900,
			"originalPrice": null
		},
		{
			"name": "Tax",
			"price": 1192,
			"originalPrice": null
		},
		{
			"name": "TOTAL",
			"price": 16092,
			"originalPrice": null
		}
	],
	"chargesSummary": {
		"discount": 0,
		"nightlyCharges": [
			{
				"postingDate": "Monday Nov 27",
				"originalTotalCharges": 14900,
				"totalCharges": 14900
			}
		],
		"originalNightlyAverage": "",
		"nightlyAverage": 14900,
		"originalSubtotal": null,
		"subTotal": 14900,
		"taxesAndFees": 1192,
		"originalTotal": null,
		"total": 16092
	}
}
 */
